import { Stack, Typography, useTheme } from "@mui/material";
import { DataGrid } from "components/DataGrid";

import { paymentSectionColumns, PaymentSectionRow } from "./lib/paymentSectionColumns";

/**
 * Read-only reference table on the fulfillment ticket: payments made on this
 * facility's previous-reporting-year report. Helps staff sanity-check this
 * year's fees (amount/payee/method) before paying.
 */
export function PreviousYearPaymentsSection({
  payments,
  reportingYear,
}: {
  payments: PaymentSectionRow[];
  reportingYear: number;
}) {
  const theme = useTheme();

  return (
    <Stack spacing={theme.spacing(1)}>
      <Typography variant="h6">Last year&apos;s payments (RY {reportingYear - 1})</Typography>
      <Typography variant="body2" color="text.secondary">
        Payments on this facility&apos;s RY {reportingYear - 1} report, for reference when paying
        this year&apos;s fees.
      </Typography>
      <DataGrid<PaymentSectionRow>
        hideFooter
        disableRowSelectionOnClick
        rows={payments}
        initialState={{ sorting: { sortModel: [{ field: "paidAt", sort: "desc" }] } }}
        columns={paymentSectionColumns}
      />
    </Stack>
  );
}
